'use client';

import { Pictogram } from '@tuic/web-compositions/core/Pictogram';
import type { PictogramName } from '@tuic/web-compositions/core/Pictogram';
import type { FC, ReactNode } from 'react';
export type ManifestSectionProps = {
  pictogram: PictogramName;
  headline?: string;
  children?: ReactNode;
};
export const ManifestSection: FC<ManifestSectionProps> = ({
  pictogram,
  headline,
  children
}) => <section className="space-y-4" data-sentry-component="ManifestSection" data-sentry-source-file="ManifestSection.tsx">
    <div className="flex items-center gap-4">
      <Pictogram name={pictogram} size="sm" data-sentry-element="Pictogram" data-sentry-source-file="ManifestSection.tsx" />
      <h2 className="text-[1.5rem] font-semibold">{headline}</h2>
    </div>

    <div className="flex flex-col gap-6 text-lg">{children}</div>
  </section>;